import api from './../api';

export default {
    namespaced: true,
    state: {},
    getters: {},
    actions: {
        delete(store, id) {
            return api.deleteRequest(store, 'application-prescription/' + id, 'Prescription was not deleted');
        },
        create(store, params) {
            return api.postRequest(
                store,
                'application-prescription/' + params.id,
                params,
                'Prescription was not created'
            );
        },
    },
    mutations: {}
}


// WEBPACK FOOTER //
// ./src/store/modules/applicationPrescriptions.js